(function() {
    angular
        .module("app")
        .factory("prefs", prefs)

    prefs.$inject = [
        "$http",
        "$rootScope",
        "authenticationService"
    ]

    function prefs(
        $http,
        $rootScope,
        authenticationService
    ) {

        //
        // Preferences:
        //
        // To create a new preference, add it to DEFAULT
        // Do NOT create any preference for secure data! (Preferences are stored unencrypted)
        //

        const DEFAULT = {
            customers: {                // SCREEN: Header / Customers
                searchType: 0                // Customer Dropdown Search Type 0 = Starts With, 1 = Full Text
            },
            devices: {                  // SCREEN: Devices
                perPage:         10,         // Number of devices shown in list, per page
                sortBy:          "name",     // Device list sorted by category (name, alerts, model, date refreshed)
                sortOrder:       "ASC",      // Device list sorting order (ASC, DESC)
                showMap:         true,       // Whether to show map (if any listed devices have GPS)
                showMapLegend:   true,       // Whether to show map legend
                showMapLabels:   true,       // Whether to show map labels for each device w/ GPS
                showMapClusters: true        // Whether to show map clusters for near-proximity/zoom devices
            },
            messageBoard: {             // SCREEN: Message Board
                showBreadcrumbs: true,     // Whether to show map breadcrumbs
                history: {                 // SCREEN: Message Board -> History
                    perPage: 10               // Number of History items shown in list, per page
                },
                messages: {                // SCREEN: Message Board -> Stored Messages
                    perPage:   10,            // Number of messages shown in list, per page
                    sortBy:    "name",        // Message list sorted by category (name, favorite, created_at)
                    sortOrder: "ASC",         // Message list sorting order (ASC, DESC)
                    showGroup: "all"          // Show Group of Messages in list (all, favorites, custom, permanent)
                }
            },
            tracker: {                  // SCREEN: Tracker
                showBreadcrumbs: true,     // Whether to show map breadcrumbs
                history: {                 // SCREEN: Tracker -> History
                    perPage: 10               // Number of History items shown in list, per page
                }
            },
            wz: {                          // SCREEN: Workzone
                showMap:         true,       // Whether to show map (if any listed devices have GPS)
                showMapLabels:   true,       // Whether to show map labels for each device w/ GPS
                showMapClusters: true,       // Whether to show map clusters for near-proximity/zoom devices
                showMapSEPath:   true,       // Whether to show map path for Start/End work zones
                history: {                   // SCREEN: Workzone -> History
                    perPage: 10                  // Number of History items shown in list, per page
                }
            }
        }

        // DEBUG: Remove Local Storage
        // window.localStorage.removeItem("userPrefs")

        const SECONDS_SAVE_SERVER_CHECK = () => { return 10  }
        const SECONDS_OLD_SERVER_DATA   = () => { return 600 }
        const SECONDS_EPOCH             = () => { return Math.floor(Date.now() / 1000) }

        let _service = {}

        let _allLocalUserPrefs  = {}
        let __allLocalUserPrefs = window.localStorage.getItem("userPrefs")

        if (__allLocalUserPrefs !== null && __allLocalUserPrefs !== undefined) {
            _allLocalUserPrefs = JSON.parse(__allLocalUserPrefs)
        }

        let _isInitializing = false
        let _hasInitialized = false

        let _currentPrefs = {}
        let _localPrefs   = {}

        let _setDefaults = () => {

            _isInitializing = false
            _hasInitialized = false

            _currentPrefs = $rootScope.deepCopy(DEFAULT)
            _currentPrefs.updatedTime = 0

            _localPrefs   = {}

        }

        _setDefaults()

        let _selectors = $rootScope.deepCopy(DEFAULT)

        let _createSelectors = (obj, keys) => {

            keys = keys === undefined ? [] : keys

            if (Object.prototype.toString.call(obj) === "[object Object]") {

                for (const key of Object.keys(obj)) {

                    keys.push(key)

                    if (Object.prototype.toString.call(obj[key]) === "[object Object]") {

                        _createSelectors(obj[key], keys)

                    } else {

                        let path = ""

                        for (const _key of keys) {
                            path += "." + _key
                        }

                        obj[key] = path.slice(1)

                    }

                    keys.pop()

                }
            }
        }

        _createSelectors(_selectors)

        let _validPrefs = (prefs) => {
            return Object.prototype.toString.call(prefs) === "[object Object]" && prefs.hasOwnProperty("updatedTime")
        }

        let _performSaveLocal = () => {

            _currentPrefs.updatedTime = SECONDS_EPOCH()

            _localPrefs = $rootScope.deepCopy(_currentPrefs)

            _allLocalUserPrefs[$rootScope.user.username] = _localPrefs
            window.localStorage.setItem("userPrefs", JSON.stringify(_allLocalUserPrefs))

        }

        let _saveLocal = (force) => {

            let _shouldSave = force || !_validPrefs($rootScope.user.preferences)

            if (!_shouldSave) {

                const _prefs1 = $rootScope.deepCopy(_localPrefs)
                const _prefs2 = $rootScope.deepCopy(_currentPrefs)

                delete _prefs1.updatedTime
                delete _prefs2.updatedTime

                _shouldSave = !$rootScope.equivalent(_prefs1, _prefs2)

            }

            if (_shouldSave) {

                _performSaveLocal()

                console.debug("[PREFS] Saved to local")

            }
        }

        let _saveServer = () => {

            let _shouldSave = !_validPrefs($rootScope.user.preferences)

            if (!_shouldSave) {

                const _prefs1 = $rootScope.deepCopy($rootScope.user.preferences)
                const _prefs2 = $rootScope.deepCopy(_currentPrefs)

                delete _prefs1.updatedTime
                delete _prefs2.updatedTime

                _shouldSave = !$rootScope.equivalent(_prefs1, _prefs2)

            }

            if (_shouldSave) {

                _performSaveLocal()

                let newPrefs = $rootScope.deepCopy(_currentPrefs)

                let prefString = JSON.stringify(newPrefs)

                if (JSON.stringify(prefString).length > 7000) {
                    console.warn("[PREFS] Preferences approaching max server size!")
                }

                let succeeded = () => {
                    console.debug("[PREFS] Saved to server")
                    $rootScope.user.preferences = newPrefs
                }

                let failed = (error) => {
                    console.error("[PREFS] Failed to save to server: ", error)
                }

                $http({
                    method: "PUT",
                    url: $rootScope.config.apiUrl + "/users/" + $rootScope.user.id + "/preferences",
                    data: {
                        preferences: prefString
                    }
                }).then(succeeded, failed)

            }
        }

        let _loopSaveServerPrefs = () => {

            if (_hasInitialized) {

                setTimeout(() => {

                    if (_hasInitialized) {

                        _saveServer()

                        _loopSaveServerPrefs()

                    }

                }, SECONDS_SAVE_SERVER_CHECK() * 1000)
            }
        }

        _service.needsAsyncInit = () => {

            return !$rootScope.user.hasOwnProperty("lastRetrieved") || $rootScope.user.lastRetrieved < SECONDS_EPOCH() - SECONDS_OLD_SERVER_DATA()

        }

        _service.deinit = () => {

            if (_hasInitialized) {

                _setDefaults()
                console.debug("[PREFS] De-initialized")

            }
        }

        _service.init = (success, failure) => {

            if (!_isInitializing && (!_hasInitialized || _service.needsAsyncInit())) {

                console.debug("[PREFS] Initialize -> start")

                _isInitializing = true

                let localPrefs = {}

                let usernames = Object.keys(_allLocalUserPrefs)

                for (let i = 0; i < usernames.length; i++) {
                    if ($rootScope.user.username === usernames[i]) {
                        localPrefs = _allLocalUserPrefs[usernames[i]]
                        break
                    }
                }

                let proceed = () => {

                    let oldPrefs = localPrefs
                    let newPrefs = $rootScope.user.preferences

                    if (_validPrefs(localPrefs) && _validPrefs($rootScope.user.preferences) && localPrefs.updatedTime > $rootScope.user.preferences.updatedTime) {
                        oldPrefs = newPrefs
                        newPrefs = localPrefs
                    }

                    if (_validPrefs(oldPrefs)) {
                        $rootScope.deepUpdate(_currentPrefs, oldPrefs)
                    }

                    if (_validPrefs(newPrefs)) {
                        $rootScope.deepUpdate(_currentPrefs, newPrefs)
                    }

                    _localPrefs = localPrefs
                    _saveLocal(false)
                    _saveServer()

                    _hasInitialized = true
                    _isInitializing = false

                    _loopSaveServerPrefs()

                    console.debug("[PREFS] Initialize -> finish")

                    if (success !== undefined) {
                        success()
                    }
                }

                if (_service.needsAsyncInit()) {

                    console.debug("[PREFS] Initialize -> Retrieving from server -> start")

                    const _success = () => {

                        console.debug("[PREFS] Initialize -> Retrieving from server -> finish")

                        proceed()

                    }

                    const _failure = () => {

                        console.debug("[PREFS] Initialize -> Requires new login")

                        failure()

                    }

                    authenticationService.refreshUser(_success, _failure)

                } else {

                    proceed()

                }
            }
        }

        _service.selectors = () => {
            return $rootScope.deepCopy(_selectors)
        }

        _service.get = () => {
            return $rootScope.deepCopy(_currentPrefs)
        }

        _service.set = (...args) => {

            if (args.length % 2 !== 0) {

                console.error("[PREFS] Preferences must be set in single or multiple groups of 2 (preference, value, ...). Invalid:", args)
                return

            }

            let needLocalSave = false

            for (let i = 0; i < args.length / 2; i++) {

                let selector = args[i * 2]
                let value    = args[i * 2 + 1]

                if (selector === undefined) {

                    console.error("[PREFS] Preferences has no 'undefined' Selector")
                    continue

                }

                let selectors = selector.split(".")

                let checkPath = (obj, _selectors) => {

                    if (_selectors.length > 0 && obj.hasOwnProperty(_selectors[0])) {

                        if (_selectors.length === 1) {
                            return true
                        } else {
                            return checkPath(obj[_selectors[0]], _selectors.slice(1))
                        }
                    }

                    return false

                }

                if (!checkPath(_currentPrefs, selectors)) {
                    console.error("[PREFS] Preferences has no '" + selector + "' Selector")
                    continue
                }

                if (value === undefined) {

                    console.error("[PREFS] Preferences Selector '" + selector + "' cannot be set to 'undefined'")
                    continue

                }

                let setPath = (obj, _selectors) => {

                    if (_selectors.length > 0 && obj.hasOwnProperty(_selectors[0])) {

                        if (_selectors.length > 2) {

                            setPath(obj[_selectors[0]], _selectors.slice(1))

                        } else if (obj[_selectors[0]][_selectors[1]] !== value) {

                            console.debug("[PREFS] Setting '" + selector + "' to: '" + value + "'")

                            needLocalSave = true

                            obj[_selectors[0]][_selectors[1]] = value

                        }
                    }
                }

                setPath(_currentPrefs, selectors)

            }

            if (needLocalSave) {
                _saveLocal(true)
            }
        }

        $rootScope.$watch("$root.is_authenticated", (newValue) => {
            if (newValue !== true) {
                _service.deinit()
            }
        })

        return _service

    }
})()
